import React from "react";
import { createRoot } from "react-dom/client";
import { BrandLockup } from "./brand";
import { LanguageSwitcher, useLocale } from "./locale";
import { AppearanceSwitcher } from "./theme";
import { homeCopy } from "./site-copy";
import "./home.css";

function Home() {
  const { locale } = useLocale();
  const content = homeCopy[locale];
  return (
    <div className="editorial-site home">
      <header className="site-header">
        <a href="/" aria-label="Crédit Mabligop home"><BrandLockup /></a>
        <nav aria-label="Main navigation"><a href="/rules">{content.howToPlay}</a><a href="#print-and-play">{content.printNav}</a><a href="/support">{content.navSupport}</a><a href="/privacy">{content.navPrivacy}</a></nav>
        <div className="site-tools"><LanguageSwitcher compact /><AppearanceSwitcher compact /></div>
      </header>

      <main>
        <section className="home-hero reveal">
          <div className="home-hero__copy">
            <span className="editorial-kicker">{content.badge}</span>
            <h1>{content.title}<br /><em>{content.heroLine}</em></h1>
            <p>{content.intro}</p>
            <div className="home-hero__actions"><a className="cm-button primary" href="/play">{content.enterBank} →</a><a className="cm-button" href="/rules">{content.howToPlay}</a></div>
            <div className="home-proof"><span><i />{content.proof[0]}</span><span>{content.proof[1]}</span><span>{content.proof[2]}</span></div>
          </div>
          <div className="home-vault" aria-hidden="true">
            <div className="vault-stamp"><span>CM</span><small>AUTHORIZED<br />NEGOCITY<br />FINANCE</small></div>
            <div className="vault-balance"><small>PLAYER BALANCE</small><strong>2,480₦</strong><span>Live · table 07</span></div>
            <div className="vault-transfer"><span>Hugo</span><b>→ 200₦ →</b><span>Maya</span></div>
          </div>
        </section>

        <section className="audiences">
          <article><span className="editorial-kicker">{content.playerLabel}</span><h2>{content.playerTitle}</h2><p>{content.features[1]?.text}</p><ul>{content.playerBullets.map((item) => <li key={item}>{item}</li>)}</ul></article>
          <article className="dark"><span className="editorial-kicker">{content.bankerLabel}</span><h2>{content.bankerTitle}</h2><p>{content.features[2]?.text}</p><ul>{content.bankerBullets.map((item) => <li key={item}>{item}</li>)}</ul></article>
        </section>

        <section id="how-it-works" className="game-loop">
          <header><span className="editorial-kicker">{content.mapLabel}</span><h2>{content.loopTitle}</h2><p>{content.mapText}</p></header>
          <div>{content.steps.map((step, index) => <article key={step.label}><b>{String(index + 1).padStart(2, "0")}</b><span><strong>{step.label}</strong><p>{step.detail}</p></span></article>)}</div>
        </section>

        <section id="print-and-play" className="print-kit">
          <div className="print-kit__preview" aria-hidden="true">
            <div className="print-sheet print-sheet--cards-left">
              <span>NEGOPOLY</span>
              <div>{Array.from({ length: 6 }, (_, index) => <i key={index} />)}</div>
            </div>
            <div className="print-sheet print-sheet--board">
              <span>NEGOPOLY <b>PLATEAU A1</b></span>
              <div><i /><i /><i /><i /></div>
            </div>
            <div className="print-sheet print-sheet--cards">
              <span>NEGOPOLY <b>VERSO</b></span>
              <div>{Array.from({ length: 9 }, (_, index) => <i key={index} />)}</div>
            </div>
          </div>
          <div className="print-kit__content">
            <header>
              <span className="editorial-kicker">{content.printBadge}</span>
              <h2>{content.printTitle}</h2>
              <p>{content.printText}</p>
            </header>
            <a className="cm-button primary" href="/downloads/negopoly-print-and-play-fr.pdf" download>
              {content.printDownload} <span aria-hidden="true">↓</span>
            </a>
            <div className="print-kit__facts">{content.printFacts.map((fact) => <span key={fact}>{fact}</span>)}</div>
            <ol>{content.printInstructions.map((instruction) => <li key={instruction}>{instruction}</li>)}</ol>
            <small>{content.printEdition}</small>
          </div>
        </section>

        <section className="home-cta"><div><span className="editorial-kicker">{content.sessionDesk}</span><h2>{content.ready}</h2><p>{content.footer}</p></div><a className="cm-button primary" href="/play">{content.start} →</a></section>
      </main>

      <footer className="site-footer"><BrandLockup compact subtitle="NegoCity" /><div><a href="/rules">{content.footerLinks[0]}</a><a href="/support">{content.footerLinks[1]}</a><a href="/privacy">{content.footerLinks[2]}</a></div><small>© 2026 Crédit Mabligop · Negopoly</small></footer>
    </div>
  );
}

createRoot(document.getElementById("root")!).render(<Home />);
